import { useQuery } from '@tanstack/react-query';
import { fetchShipmentByOrderId } from '../api/shipmentByOrder.api';

export const useShipmentByOrderId = (orderNumber: string) =>
  useQuery({
    queryKey: ['shipmentByOrder', orderNumber],
    queryFn: () => fetchShipmentByOrderId(orderNumber),
    enabled: !!orderNumber
  });
